// src/components/CampaignWizard/StepAudience.tsx
import React from "react";
import {
	Row,
	Col,
	FormGroup,
	Label,
	Input,
	FormText,
} from "reactstrap";
import Filter from "./Filter/Filter";               // ← your existing Filter

export type AudienceType = "STATIC" | "DYNAMIC";
export interface StepAudienceProps {
	data: {
		type: AudienceType;
		csvFile?: File | null;
		filterGroups: any[];
	};
	dataFields: any[];  // pass in whatever fields you want the filter to use
	onChange: (
		patch: Partial<{
			type: AudienceType;
			csvFile: File | null;
			filterGroups: any[];
		}>
	) => void;
	onNext: () => void;
	onBack: () => void;
	t: (key: string) => string;
}

const StepAudience: React.FC<StepAudienceProps> = ({
	data,
	dataFields,
	onChange,
	t,
}) => {
	const pickFile = (e: React.ChangeEvent<HTMLInputElement>) => {
		const f = e.target.files?.[0] ?? null;
		onChange({ type: "STATIC", csvFile: f, filterGroups: [] });
	};

	return (
		<>
			{/* ── Choose STATIC vs DYNAMIC ───────────────────────── */}
			<Row className="mb-3">
				<Col>
					<FormGroup check inline>
						<Input
							type="radio"
							id="aud-static"
							name="audType"
							checked={data.type === "STATIC"}
							onChange={() =>
								onChange({ type: "STATIC", csvFile: null, filterGroups: [] })
							}
						/>
						<Label for="aud-static" check className="ms-2">
							{t("Static (CSV)")}
						</Label>
					</FormGroup>
					<FormGroup check inline>
						<Input
							type="radio"
							id="aud-dynamic"
							name="audType"
							checked={data.type === "DYNAMIC"}
							onChange={() =>
								onChange({ type: "DYNAMIC", filterGroups: [] })
							}
						/>
						<Label for="aud-dynamic" check className="ms-2">
							{t("Dynamic (Filters)")}
						</Label>
					</FormGroup>
					<FormText color="muted" className="mt-1">
						{data.type === "STATIC"
							? t("Upload a CSV of recipient IDs, one per line.")
							: t("Build one or more condition groups to target your audience.")}
					</FormText>
				</Col>
			</Row>

			{/* ── STATIC: CSV upload ───────────────────────────────── */}
			{data.type === "STATIC" && (
				<Row className="mb-4">
					<Col md={6}>
						<Input type="file" accept=".csv" onChange={pickFile} />
						{data.csvFile && (
							<FormText color="success" className="mt-1">
								{t("Selected file")}: {data.csvFile.name}
							</FormText>
						)}
					</Col>
				</Row>
			)}

			{/* ── DYNAMIC: your Filter widget ──────────────────────── */}
			{data.type === "DYNAMIC" && (
				<Row className="mb-4">
					<Col>
						<Filter
							dataFields={dataFields}
							groups={data.filterGroups}
							updateGroups={(groups) => onChange({ filterGroups: groups })}
							t={t}
						/>
					</Col>
				</Row>
			)}
		</>
	);
};

export default StepAudience;
